import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const InlineLabel = styled.span({
    marginLeft: 20,
    marginRight: 10,
});

export const ItemLabel = styled.div<{ width?: number | string; align?: "top" | "center" | "bottom" }>(
    props => ({
        display: "inline-block",
        color: theme(props).typography.primary.color,
        lineHeight: "20px",
        width: props.width,
    }),
    props =>
        props.align === "top" && {
            marginTop: 7,
            alignSelf: "flex-start",
        },
    props =>
        props.align === "center" && {
            alignSelf: "center",
        },
    props =>
        props.align === "bottom" && {
            alignSelf: "flex-end",
        }
);

export const ItemValue = styled.div<{ width?: number | string }>(props => ({
    display: "inline-block",
    width: props.width,
}));

export const ListItemWithMarker = styled.li<{ indent?: boolean; itemMarker: "bullet" | "dash" }>(
    props => ({
        listStyleType: "none",
        listStylePosition: "outside",
        position: "relative",

        ":before": {
            content: props.itemMarker === "dash" ? "'-'" : "'•'",
            color: props.theme.candy.brandColors.panelColor,
            position: "absolute",
            left: "-14px",
        },
    }),
    props => props.indent && { marginLeft: 20 }
);

interface ListItemRootProps {
    indent?: boolean;
    paddings?: boolean;
    width?: number | string;
    paddingTop?: number | string;
    paddingBottom?: number | string;
}

export const ListItemRoot = styled("div")<ListItemRootProps>(
    {
        display: "flex",
        alignItems: "baseline",
        verticalAlign: "baseline",
        overflowWrap: "break-word",
        wordWrap: "break-word",
        wordBreak: "break-word",
    },
    props => props.indent && { marginLeft: 20 },
    props =>
        props.paddings && {
            paddingTop: 15,
            paddingBottom: 15,
        },
    props => ({
        width: props.width,
        paddingTop: props.paddingTop,
        paddingBottom: props.paddingBottom,
    })
);
